import { ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextPropsOptionalVariant } from '@components/Text/Text.types';
import classnames from 'classnames';

const PlcCell: FC<PropsWithChildren<ComponentPropsWithRef<'td'> & { textProps?: TextPropsOptionalVariant }>> = ({
  className,
  children,
  textProps = {},
  ...rest
}) => {
  const rootClass = classnames('plc-table-cell', className);
  const { variant = 'tiny-title', tag = 'div', ...restTextProps } = textProps;
  return (
    <td className={rootClass} {...rest}>
      <Text tag={tag} variant={variant} {...restTextProps}>
        {children}
      </Text>
    </td>
  );
};

export { PlcCell };
